// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__22cOf","name":"ConsentHeader_name__3cTNo","birthday":"ConsentHeader_birthday__6NAXC","skeleton":"ConsentHeader_skeleton__2MBxO"};